var map = {
	"./ActForex-white.png": "0226",
	"./CTrader-white.png": "492d",
	"./CloudTrade-white.png": "f5a1",
	"./DXTrade-white.png": "c302",
	"./MT4-white.png": "eea5",
	"./MT5-white.png": "886a",
	"./Promena-white.png": "2fe5",
	"./TD365-white.png": "4538",
	"./icon-Cloud-SingleCurrencyTrading-white.png": "c469"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2384";